import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ChatCircleText } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found');
        navigate('/login');
        return;
      }

      try {
        // Exchange session_id for our session token
        const response = await fetch(`${API}/auth/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.detail || 'Authentication failed');
        }

        const data = await response.json();
        
        // Clear the URL fragment and navigate to dashboard with user data
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { state: { user: data.user }, replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        // Show error message and redirect to login
        navigate('/login', { 
          state: { error: error.message || 'Autentifikation fejlede' },
          replace: true 
        });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-xl bg-indigo-700 flex items-center justify-center">
          <ChatCircleText className="w-7 h-7 text-white" weight="duotone" />
        </div>
        <span 
          className="text-2xl font-bold text-slate-900"
          style={{ fontFamily: 'Manrope, sans-serif' }}
        >
          GardinBot
        </span>
      </div>
      <div className="flex items-center gap-2 text-slate-600">
        <div className="w-5 h-5 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin" />
        <span>Logger ind...</span>
      </div>
    </div>
  );
};
